import React from 'react';
import { BitcoinIcon, CoinsIcon, LineChartIcon, RefreshCwIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { TradingViewWidget } from './TradingViewWidget';
const CATEGORIES = [{
  label: 'Forex',
  Icon: RefreshCwIcon
}, {
  label: 'Índices',
  Icon: LineChartIcon
}, {
  label: 'Metales',
  Icon: CoinsIcon
}, {
  label: 'Criptomonedas',
  Icon: BitcoinIcon
}];
const TICKER_CONFIG = {
  symbols: [{
    proName: 'OANDA:XAUUSD',
    title: 'Oro'
  }, {
    proName: 'FX:EURUSD',
    title: 'EUR/USD'
  }, {
    proName: 'FX:GBPJPY',
    title: 'GBP/JPY'
  }, {
    proName: 'OANDA:NAS100USD',
    title: 'US 100'
  }, {
    proName: 'BITSTAMP:BTCUSD',
    title: 'BTC/USD'
  }, {
    proName: 'OANDA:XAGUSD',
    title: 'Plata'
  }],
  colorTheme: 'dark',
  locale: 'es',
  largeChartUrl: '',
  isTransparent: true,
  showSymbolLogo: true,
  displayMode: 'compact'
};
export function TrustBar() {
  return <>
      <div className="bg-brand-950" aria-label="Cotizaciones de mercado en vivo" data-id="element-215" data-mp="ajer12p8hekk">
        <div className="relative z-10 min-h-[46px] pb-3" data-id="element-216" data-mp="1aindlj4mw1gw">
          <TradingViewWidget kind="ticker-tape" config={TICKER_CONFIG} data-id="element-217" data-mp="1aj6y97lo53ym" />
        </div>
      </div>

      <section aria-label="Categorías de mercado" className="relative border-b border-line bg-white" data-id="element-218" data-mp="16j4tgpkmzuf4">
        <Reveal className="mx-auto flex max-w-[1400px] flex-col items-center gap-7 px-5 py-9 lg:flex-row lg:justify-between lg:px-8" data-id="element-219" data-mp="1fi00u4zf3ak0">
          <p className="text-center text-[11px] font-semibold uppercase tracking-overline text-ink-400 lg:text-left" data-id="element-220" data-mp="1tgztdnq1w9lg">
            Una experiencia diseñada para el trader moderno
          </p>
          <ul className="grid w-full grid-cols-2 gap-x-8 gap-y-4 sm:flex sm:w-auto sm:items-center sm:gap-10" data-id="element-221" data-mp="237udomjqkz49">
            {CATEGORIES.map(({
            label,
            Icon
          }) => <li key={label} className="flex items-center gap-2.5 text-[13px] font-semibold text-ink-700" data-id="element-222" data-mp="1yau8seymi2eq">
                <Icon className="h-4 w-4 text-brand-600" aria-hidden="true" data-id="element-223" data-mp="287yu6ckn9tuh" />
                {label}
              </li>)}
          </ul>
        </Reveal>
      </section>
    </>;
}